import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="criterion-period-form"
export default class extends Controller {

	static targets = [
		'periodicityLabel',
		'periodicityInput',
		'periodNameRow',
		'addNewCriterionPeriod',
		'literalPeriodicityExplainer',
	]

	connect() {
		this.periodicityChanged()
	}

	periodicityChanged(_event) {
		switch (this.periodicityInputTarget.value) {
			case 'literal':
				this.displayLiteralMode(true)
				break;

			default:
				this.displayLiteralMode(false)
				break;
		}
	}

	displayLiteralMode(show_div) {
		const literalModeElements = this.element.querySelectorAll('[data-criterion-period-literal-only]')
		const nonliteralModeElements = this.element.querySelectorAll('[data-criterion-period-literal-hidden]')

		if (show_div) {
			literalModeElements.forEach( (element) => element.classList.remove('d-none') )
			nonliteralModeElements.forEach( (element) => element.classList.add('d-none') )
		} else {
			literalModeElements.forEach( (element) => element.classList.add('d-none') )
			nonliteralModeElements.forEach( (element) => element.classList.remove('d-none') )
		}
	}

}
